import { render, staticRenderFns } from "./SearchBarFilter.vue?vue&type=template&id=867df13a&scoped=true&"
import script from "./SearchBarFilter.vue?vue&type=script&lang=js&"
export * from "./SearchBarFilter.vue?vue&type=script&lang=js&"
import style0 from "./SearchBarFilter.vue?vue&type=style&index=0&id=867df13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867df13a",
  null
  
)

export default component.exports